import React, { Component } from 'react';
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Toaster from "toastr";
import Breadcrumbs from "react-breadcrumbs";
import Constants from "../../../configurations/constants";
import Messages from "../../../configurations/messages";
import DisputesAPI from "../../../api/DisputesApi";
import Util from "../../../util/util";
import BulkAcceptFilter from './BulkAcceptFilter';
import BulkAcceptDisputesTable from './BulkAcceptTable';

class BulkAccept extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
          actionLoading: false,
          tableData: [],
          totalCount: 0,
          selectedDispute: null,
          loading: false,
          showTable: false,
          pages: 0,
          pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
          pageNum: 0, //Zero based index
          filterParams: null,
          stop_pinging: false,
          generating: [],
          reportsProgress: [],
          transactionGroups: [],
          selection: [],
          selectAll: false,
          params: {},
          resetSelection: false
        }
    }
    paginateid = (index) => {
        const offset = parseInt(this.state.pageNum, 0);
        //const idx = parseInt(index, 0);
        const pagesize = parseInt(this.state.pageSize, 0);
        const result =
          offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
        return result.toString();
    }
    onTableChange =(state, instance)=> {
        let pageSize = instance.state.pageSize;
        let pageNum = instance.state.page; //table page  - Zero based index
        this.setState({ pageSize: pageSize, pageNum: pageNum });
        if (this.state.filterParams) {
          let params = Util.clone(this.state.filterParams);
          params.pageSize = pageSize;
          params.pageNum = pageNum + 1;
    
          this.onSearchHandler(params);
        }
    }
    onDisputeRowClick=(index)=> {
        this.setState({ selectedDispute: this.state.tableData[index] });
    }
    onSearchHandler = (params, resetPageNumber) => {
        //Reset states
        let stateUpdate = { loading: true, tableData: [], selection: [], selectAll: false };
        if (resetPageNumber) {
          stateUpdate.pageNum = 0;
          params.pageNum = 1;
        }
        this.setState(stateUpdate)
        params.pageSize = params.pageSize || this.state.pageSize;
        params.pageNum = params.pageNum || this.state.pageNum + 1;
        DisputesAPI.findBulkAcceptDisputes(params)
          .then(response => {
            let data = response.data.content;
            data = data.map(d => {
              return {
                ...d,
                transactionDate: Util.toUserLocalTime(d.transactionDate),
                createdOn: Util.toUserLocalTime(d.createdOn),
                statusStartDate: Util.toUserLocalTime(d.statusStartDate),
                statusScheduledEndDate: Util.toUserLocalTime(
                  d.statusScheduledEndDate
                )
              };
            });
            let totalCount = response.data.count;
            let pages = totalCount
              ? Math.ceil(
                  totalCount /
                    (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
                )
              : 0;
            if (data.length === 0) Toaster.warning("No records found.", "Disputes");
    
            this.setState({
              tableData: data,
              loading: false,
              filterParams: params,
              totalCount: totalCount,
              pages: pages
            });
          })
          .catch(error => {
            console.log(error);
            Util.errorMessageToast(Toaster, error.data, [
              `${Messages.ERROR_DISPUTES_SEARCH}`,
              `${Messages.ERROR_DISPUTES_SEARCH_TITLE}`
            ]);
            this.setState({ loading: false });
          });
    }
    updateSelection = arr => {
      this.setState({
        selection: arr
      })
    }
    updateSelectAll = value => {
      this.setState({
        selectAll: value
      })
    }
    onTransactionGroupChange = (value) => {
      this.setState({
        transactionGroups: value ? value : []
      });
    }
    onParamChange = params => {
      this.setState({ params })
    }
    acceptDeclineHandler = (status) => {
      this.setState({ actionLoading: true }, () => {
          const body = {
          category: this.state.params.category,
          action: status,
          logCodes: [...this.state.selection]
        };
        DisputesAPI.acceptOrDeclineBulkDisputes(body)
        .then((response)=> {
          this.onSearchHandler(this.state.params, true)
          Toaster.success(`Bulk Dispute ${status} request has been succefully submitted for processing.`)
          this.setState({ actionLoading: false });
        })
        .catch(error => {
          console.log(error);
          Util.errorMessageToast(Toaster, error.data, [
            `${Messages.ERROR_BULK_DISPUTES_UPDATE}`,
          ]);
          this.setState({ actionLoading: false });
        });
      });
    }
    render() {
        return (
            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                  <Breadcrumbs
                    separator={Constants.BREADCRUMB_SEPARATOR}
                    routes={this.props.routes}
                    params={this.props.params}
                  />
                </div>
                <PageTitle title="Bulk Updates" />
                <BulkAcceptFilter 
                  onSearchHandler={this.onSearchHandler} 
                  updateParentTG={this.onTransactionGroupChange} 
                  updateParentParams={this.onParamChange}
                  loading={this.state.loading}
                />
                <Divider />
                <BulkAcceptDisputesTable 
                  onRowClick={this.onDisputeRowClick}
                  tableData={this.state.tableData}
                  loading={this.state.loading}
                  onTableChange={this.onTableChange}
                  transactionGroups={this.state.transactionGroups}
                  page={this.state.pageNum}
                  pageSize={this.state.pageSize}
                  pages={this.state.pages}
                  defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                  paginatedCallBack={this.paginateid}
                  acceptDeclineHandler={this.acceptDeclineHandler}
                  actionLoading={this.state.actionLoading}
                  updateSelectAll={this.updateSelectAll}
                  updateSelection={this.updateSelection}
                  selectAll={this.state.selectAll}
                  selection={this.state.selection}
                />
            </div>
        )
    }
}
export default BulkAccept;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulk_accept/BulkAccept.js